// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ComponentSideBySideImageFragmentDoc } from './side-by-side-images/ComponentSideBySideImage.fragment.generated';
export const ComponentSideBySideImagesFragmentDoc = gql`
    fragment componentSideBySideImages on ComponentSideBySideImages {
  images {
    ...componentSideBySideImage
  }
}
    ${ComponentSideBySideImageFragmentDoc}`;